var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { wait } from "./utils";
/**
 * InMobi + Evo + MSN implementation of CMP.
 * Takes into account `window.__gpp`, `3PAdsOptOut` cookie, `navigator.doNotTrack`
 */
export class CMP {
    constructor(scope) {
        this.scope = scope;
    }
    callCMP(method, params) {
        return new Promise((resolve) => this.scope.__gpp(method, resolve, params));
    }
    waitGPP() {
        return __awaiter(this, arguments, void 0, function* (retry = 0) {
            if (!this.scope.__gpp && retry < 3) {
                return wait(100)
                    .then(() => this.waitGPP(retry + 1));
            }
            ;
            if (!this.scope.__gpp)
                return true;
            return new Promise((resolve) => {
                this.scope.__gpp('addEventListener', ({ pingData }) => {
                    if (pingData.cmpStatus !== 'loaded')
                        return;
                    if (pingData.signalStatus !== 'ready')
                        return;
                    if (pingData.applicableSections.length === 0)
                        return resolve(true);
                    if (Object.keys(pingData.parsedSections).length !== 0)
                        return resolve(true);
                });
            });
        });
    }
    getResponse() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            // Read Firefox DNT value
            if (((_a = this.scope.navigator) === null || _a === void 0 ? void 0 : _a.doNotTrack) === '1' || ((_b = this.scope.navigator) === null || _b === void 0 ? void 0 : _b.globalPrivacyControl)) {
                return { hasOptedOut: true };
            }
            // Read MSFT 3PAdsOptOut
            if ((_d = (_c = this.scope.document) === null || _c === void 0 ? void 0 : _c.cookie) === null || _d === void 0 ? void 0 : _d.includes('3PAdsOptOut')) {
                return { hasOptedOut: true };
            }
            yield this.waitGPP();
            try {
                const hasOptedOut = this.scope.localStorage.getItem('ark_modules:targetingConsent') === 'false' ? true : false;
                ;
                return { hasOptedOut };
            }
            catch (e) {
                console.error(e);
                return { hasOptedOut: false };
            }
        });
    }
}
